// Configuración del registro público: versión de términos aceptada y site key de reCAPTCHA.

/**
 * Versión de los términos de uso vigente. Al cambiar los términos, subir esta versión;
 * se guarda en Tenant.acceptedTermsVersion al registrarse para saber qué versión aceptó cada quien.
 */
export const TERMS_VERSION = "2026-07-04";

/**
 * Site key pública de Google reCAPTCHA v3 (no es secreta; el secret vive en el lambda pre-sign-up).
 * Configurable por env; fallback vacío (el pre-sign-up permite el registro si no hay secreto/token
 * configurado, así que en ambientes sin reCAPTCHA no bloquea).
 */
export const RECAPTCHA_SITE_KEY: string =
  ((import.meta.env as Record<string, string | undefined>)?.VITE_RECAPTCHA_SITE_KEY) ?? "";
